import * as THREE from 'three'
import Experience from '../Experience';
import gsap from 'gsap'
import EventEmitter from './EventEmitter.js'
import UISegmentOne from './UISegmentOne';
import UISegmentTwo from './UISegmentTwo';
import { EqualStencilFunc, Vector3 } from 'three';
import UISegmentThree from './UISegmentThree';
import UISegmentFour from './UISegmentFour';
import UISegmentFive from './UISegmentFive';
import UISegmentSix from './UISegmentSix';


export default class UI extends EventEmitter
{
    constructor()
    {
        super()
        this.experience = new Experience();
        this.resources = this.experience.resources;
        this.world = this.experience.world;
        this.input = this.experience.input;
        this.camera = this.experience.camera;
        this.sizes = this.experience.sizes;
        this.uiSegmentOne = new UISegmentOne();
        this.uiSegmentTwo = new UISegmentTwo();
        this.uiSegmentThree = new UISegmentThree();
        this.uiSegmentFour = new UISegmentFour();
        this.uiSegmentFive = new UISegmentFive();
        this.uiSegmentSix = new UISegmentSix();
        this.mode = 0;
        
        this.x = {t:0};
        this.dropState = -1;
        this.completeIntro = false;
        this.mainIcon = document.querySelector('.main')
        this.secondIcon = document.querySelector('.second')
        this.grayIcon = document.querySelector('.gray')
        this.helpImg = document.querySelector('.rotation')
        this.dragImg = document.querySelector('.dragH')
        this.screenHelpPosition;
        this.translateX;
        this.translateY;

        //this.loadingBarElement = document.querySelector('.loading-bar')      
        this.segmentButton1 = document.querySelector('.segment-1')
        this.segmentButton2 = document.querySelector('.segment-2')
        this.segmentButton3 = document.querySelector('.segment-3')
        this.segmentButton4 = document.querySelector('.segment-4')
        this.segmentButton5 = document.querySelector('.segment-5')
        this.segmentButton6 = document.querySelector('.segment-6')  

        this.leftButton = document.getElementById("left")
        this.leftButton.addEventListener("click", ()=>{
            this.mainIcon.classList.remove('visible')
            this.mainIcon.classList.add('invisible')
            this.secondIcon.classList.add('visible')
            this.segmentButton1.classList.remove('visible')  
            this.segmentButton2.classList.remove('visible')   
            this.segmentButton3.classList.remove('visible')       
            this.segmentButton4.classList.remove('visible')       
            this.segmentButton5.classList.remove('visible')       
            this.segmentButton6.classList.remove('visible')     
            this.leftButton.classList.remove('visible')       
            this.rightButton.classList.remove('visible')    
            this.trigger('leftCamera');
        },false)
        this.rightButton = document.getElementById("right")
        this.rightButton.addEventListener("click", ()=>{
            this.mainIcon.classList.remove('visible')
            this.mainIcon.classList.add('invisible')
            this.secondIcon.classList.add('visible')
            this.segmentButton1.classList.remove('visible')  
            this.segmentButton2.classList.remove('visible')   
            this.segmentButton3.classList.remove('visible')       
            this.segmentButton4.classList.remove('visible')       
            this.segmentButton5.classList.remove('visible')       
            this.segmentButton6.classList.remove('visible')    
            this.leftButton.classList.remove('visible')       
            this.rightButton.classList.remove('visible')  
            this.trigger('rightCamera');     
        },false)
        
        this.SetupAreaButtons();
        this.footerTxt = document.querySelector('.foot')
        this.headerTxt = document.querySelector('.head')
        this.segmentLabel1 = document.querySelector('.label-1')
        this.segmentLabel2 = document.querySelector('.label-2')
        this.segmentLabel3 = document.querySelector('.label-3')
        this.segmentLabel4 = document.querySelector('.label-4')
        this.segmentLabel5 = document.querySelector('.label-5')
        this.segmentLabel6 = document.querySelector('.label-6')
        
        this.closeBtnElement = document.querySelector('.closeBtn')         
        this.closeButton = document.getElementById("close")
        this.closeButton.addEventListener("click", ()=>{
            if(this.dropState == -1)
            {
            this.dragImg.classList.remove('visible')
            this.dragImg.classList.add('invisible')
            this.trigger('unloadSegment');
            }
            else
            {
                switch(this.dropState)
                {
                    case 1: 
                    this.uiSegmentOne.closeDrop();
                    break;
                    case 2: 
                    this.uiSegmentTwo.closeDrop();
                    break;
                    case 3: 
                    this.uiSegmentThree.closeDrop();
                    break;
                    case 4: 
                    this.uiSegmentFour.closeDrop();
                    break;
                    case 5: 
                    this.uiSegmentFive.closeDrop();
                    break;
                    case 6: 
                    this.uiSegmentSix.closeDrop();
                    break;
                }
            }
        },true) 
        
        this.catBtn = document.querySelector('.cat');
        this.catButton = document.getElementById("viewCat");
        this.catButton.addEventListener("click", ()=>{
            window.open("https://optronics.com.mx/conectividad/views/catalogo/", "_blank")
        })
        this.labelOffset= 16;      
        this.xLabelOffset1 = -4;
        this.xLabelOffset2 = -3;
        this.xLabelOffset3 = -2;
        this.xLabelOffset4 = -1;
        this.xLabelOffset5 = 0;
        this.xLabelOffset6 = 1;
    }
    SetupAreaButtons()
    {
        this.s1Button = document.getElementById("btn-1")
        this.s1Button.addEventListener("click", ()=>{
            this.UnloadArea();
        },true)     
        this.s2Button = document.getElementById("btn-2")
        this.s2Button.addEventListener("click", ()=>{
            this.UnloadArea();
        },true)
        this.s3Button = document.getElementById("btn-3")
        this.s3Button.addEventListener("click", ()=>{            
            this.UnloadArea();
        },true)
        this.s4Button = document.getElementById("btn-4")
        this.s4Button.addEventListener("click", ()=>{
            this.UnloadArea();
        },true)
        this.s5Button = document.getElementById("btn-5")
        this.s5Button.addEventListener("click", ()=>{
            this.UnloadArea();
        },true)
        this.s6Button = document.getElementById("btn-6")
        this.s6Button.addEventListener("click", ()=>{
            this.UnloadArea();
        },true)     
    }

    UnloadArea()
    {
        this.mainIcon.classList.remove('visible')
        this.mainIcon.classList.add('invisible')
        this.secondIcon.classList.add('visible')
        this.trigger('unloadArea');
    }

    progressorEnded()
    {
        if(this.experience.state == null)
        {
            var y = {t:1};
            gsap.to(y, { 
            duration:0.8, 
            t: 0, 
            onComplete: ()=>{                
                this.headerTxt.classList.add('visible');
            }
            }).play();
        }
    }

    onStartDownAnimation()
    {        
        this.headerTxt.classList.remove('visible');
    }
    onEndIntro()
    {       
        var timeToHelp = {t:0};
        gsap.to(timeToHelp, {       
            t:3,                 
            duration: 3,
            delay: 0.2,    
            onStart: ()=>
            {
                if(this.input.firstInteraction)
                {
                this.helpImg.classList.add('visible')                    
                this.mainIcon.classList.add('visible');
                this.grayIcon.classList.add('halfVisible'); 
                this.grayIcon.src = "https://xrlab.studio/dev/Splittel/images/optronicsGray.png";
                }
                /*this.segmentButton1.classList.add('visible');
                this.segmentButton2.classList.add('visible');
                this.segmentButton3.classList.add('visible');
                this.segmentButton4.classList.add('visible');
                this.segmentButton5.classList.add('visible');
                this.segmentButton6.classList.add('visible');*/
                //console.log(this.experience.screenType)
                if(this.experience.screenType != 2 && this.input.firstInteraction)
                {
                    this.segmentLabel1.classList.add('visible');
                    this.segmentLabel1.classList.add('visible');
                    this.segmentLabel2.classList.add('visible');
                    this.segmentLabel3.classList.add('visible');
                    this.segmentLabel4.classList.add('visible');
                    this.segmentLabel5.classList.add('visible');
                    this.segmentLabel6.classList.add('visible');
                    this.footerTxt.classList.add('visible');
                }
                else
                {
                    this.updateSegments();
                }
                this.completeIntro = true;
            }, 
            onComplete: ()=> 
            {
                this.helpImg.classList.remove('visible')
                this.helpImg.classList.add('invisible')
            }
        }).play();
    }

    poISelected()
    {
        this.segmentLabel1.classList.remove('visible');
        this.segmentLabel1.classList.remove('visible');
        this.segmentLabel2.classList.remove('visible');
        this.segmentLabel3.classList.remove('visible');
        this.segmentLabel4.classList.remove('visible');
        this.segmentLabel5.classList.remove('visible');
        this.segmentLabel6.classList.remove('visible');     
        this.footerTxt.classList.add('invisible');
        this.helpImg.classList.remove('visible')
        this.helpImg.classList.add('invisible')

        this.mainIcon.classList.remove('visible')
        this.mainIcon.classList.add('invisible')
        this.secondIcon.classList.add('visible')
        
        this.footerTxt.classList.remove('visible');
        this.segmentButton1.classList.remove('visible')  
        this.segmentButton2.classList.remove('visible')   
        this.segmentButton3.classList.remove('visible')       
        this.segmentButton4.classList.remove('visible')       
        this.segmentButton5.classList.remove('visible')       
        this.segmentButton6.classList.remove('visible')       
        this.leftButton.classList.remove('visible')       
        this.rightButton.classList.remove('visible')    
        this.updateSegments();
    }

    backButton()
    {

    }

    onFirstInteraction()
    {
        this.segmentLabel1.classList.remove('visible');
        this.segmentLabel1.classList.remove('visible');
        this.segmentLabel2.classList.remove('visible');
        this.segmentLabel3.classList.remove('visible');
        this.segmentLabel4.classList.remove('visible');
        this.segmentLabel5.classList.remove('visible');
        this.segmentLabel6.classList.remove('visible');     
        this.footerTxt.classList.add('invisible');
        this.helpImg.classList.remove('visible')       
    }
    
    onLoading()
    {
        /*const progressRatio = (this.resources.loaded / this.resources.toLoad)
        this.loadingBarElement.style.transform = `scaleX(${progressRatio})`*/
    }

    onLoaded()
    {
        /*this.loadingBarElement.classList.add('ended')
        this.loadingBarElement.style.transform = ''*/
    }
    quickEntry()
    {        
        this.secondIcon.classList.add('visible')
        this.segmentButton1.classList.remove('visible')  
        this.segmentButton2.classList.remove('visible')   
        this.segmentButton3.classList.remove('visible')       
        this.segmentButton4.classList.remove('visible')       
        this.segmentButton5.classList.remove('visible')       
        this.segmentButton6.classList.remove('visible')     
        this.grayIcon.src = "https://xrlab.studio/dev/Splittel/images/optronicsGray.png";
        this.grayIcon.classList.add('halfVisible'); 
        switch(this.experience.curIndex)
        {
            case 0:
            this.segmentButton1.classList.add('visible')   
            break
        case 1:      
            this.segmentButton2.classList.add('visible')    
            break
        case 2:
            this.segmentButton3.classList.add('visible')     
            break
        case 3:
            this.segmentButton4.classList.add('visible')         
            break
        case 4:   
            this.segmentButton5.classList.add('visible')          
            break
        case 5:  
            this.segmentButton6.classList.add('visible')          
            break
        }
        this.leftButton.classList.add('visible')       
        this.rightButton.classList.add('visible')
       
    }

    update()
    {
        if(this.input.firstInteraction && this.mode == 0)
        {
            if(this.world.island1 != null)
            {
                this.screenHelpPosition = this.world.island1.model.position.clone()
                this.screenHelpPosition.y -= this.labelOffset;
                this.screenHelpPosition.x += this.xLabelOffset1;
                this.screenHelpPosition.project(this.camera.instance)
                this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
                this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
                this.segmentLabel1.style.transform = `translateX(${this.translateX}px) translateY(${this.translateY}px)`
            }
            if(this.world.island2 != null)
            {
                this.screenHelpPosition = this.world.island2.model.position.clone()
                this.screenHelpPosition.y -= this.labelOffset;
                this.screenHelpPosition.x += this.xLabelOffset2;
                this.screenHelpPosition.project(this.camera.instance)
                this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
                this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
                this.segmentLabel2.style.transform = `translateX(${this.translateX}px) translateY(${this.translateY}px)`
            }
            if(this.world.island3 != null)
            {
                this.screenHelpPosition = this.world.island3.model.position.clone()
                this.screenHelpPosition.y -= this.labelOffset;
                this.screenHelpPosition.x += this.xLabelOffset3;
                this.screenHelpPosition.project(this.camera.instance)
                this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
                this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
                this.segmentLabel3.style.transform = `translateX(${this.translateX}px) translateY(${this.translateY}px)`
            }
            if(this.world.island4 != null)
            {
                this.screenHelpPosition = this.world.island4.model.position.clone()
                this.screenHelpPosition.y -= this.labelOffset;
                this.screenHelpPosition.x += this.xLabelOffset4;
                this.screenHelpPosition.project(this.camera.instance)
                this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
                this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
                this.segmentLabel4.style.transform = `translateX(${this.translateX}px) translateY(${this.translateY}px)`
            }
            if(this.world.island5 != null)
            {
                this.screenHelpPosition = this.world.island5.model.position.clone()
                this.screenHelpPosition.y -= this.labelOffset;
                this.screenHelpPosition.x += this.xLabelOffset5;
                this.screenHelpPosition.project(this.camera.instance)
                this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
                this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
                this.segmentLabel5.style.transform = `translateX(${this.translateX}px) translateY(${this.translateY}px)`
            }
            if(this.world.island6 != null)
            {
                this.screenHelpPosition = this.world.island6.model.position.clone()
                this.screenHelpPosition.y -= this.labelOffset;
                this.screenHelpPosition.x += this.xLabelOffset6;
                this.screenHelpPosition.project(this.camera.instance)
                this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
                this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
                this.segmentLabel6.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)`
            }
        }
        else if(this.mode == 1)
        {
            switch(this.experience.curIndex)
            {
                case 0:
                    this.uiSegmentOne.update();
                    break;
                case 1:
                    this.uiSegmentTwo.update();
                    break;
                case 2:
                    this.uiSegmentThree.update();
                    break;
                case 3:
                    this.uiSegmentFour.update();
                    break;
                case 4:
                    this.uiSegmentFive.update();
                    break;
                case 5:
                    this.uiSegmentSix.update();
                    break;
            }
        }
        
    }

    
    updateSegments()
    {
        switch(this.experience.curIndex)
        {
            case 0:
            this.segmentButton1.classList.add('visible')   
            break
        case 1:      
            this.segmentButton2.classList.add('visible')    
            break
        case 2:
            this.segmentButton3.classList.add('visible')     
            break
        case 3:
            this.segmentButton4.classList.add('visible')         
            break
        case 4:   
            this.segmentButton5.classList.add('visible')          
            break
        case 5:  
            this.segmentButton6.classList.add('visible')          
            break
        }
        this.leftButton.classList.add('visible')       
        this.rightButton.classList.add('visible')        
    }

    swapToSegmentStart()
    {        
        //console.log("swap to segment start");
        this.footerTxt.classList.remove('visible');
        this.segmentButton1.classList.remove('visible')  
        this.segmentButton2.classList.remove('visible')   
        this.segmentButton3.classList.remove('visible')       
        this.segmentButton4.classList.remove('visible')       
        this.segmentButton5.classList.remove('visible')       
        this.segmentButton6.classList.remove('visible')       
        this.leftButton.classList.remove('visible')       
        this.rightButton.classList.remove('visible')    
        this.grayIcon.src = "https://xrlab.studio/dev/Splittel/images/optronicsWhite.png";
        this.grayIcon.classList.remove('halfVisible');
        this.grayIcon.classList.add('visible');
    }
    swapToSegmentEnd()
    {    
        this.mode = 1;        
        switch(this.experience.curIndex)
        {
            case 0:                
                this.uiSegmentOne.updateDots();
            break;
            case 1:
                this.uiSegmentTwo.updateDots();
            break;
            case 2:
                this.uiSegmentThree.updateDots();
            break;
            case 3:
                this.uiSegmentFour.updateDots();
            break;
            case 4:
                this.uiSegmentFive.updateDots();
            break;
            case 5:
                this.uiSegmentSix.updateDots();
            break;
        }
        var timeToHelp = {t:0};
        gsap.to(timeToHelp, {       
            t:3,                 
            duration: 3,
            delay: 1.5,    
            onStart: ()=>
            {
                this.dragImg.classList.remove('invisible')
                this.dragImg.classList.add('visible')      
                if(this.experience.curIndex == 4)
                this.dragImg.classList.add('up');
                else
                this.dragImg.classList.add('side');
            }, 
            onComplete: ()=> 
            {
                this.dragImg.classList.remove('visible')
                //this.dragImg.classList.add('invisible')
                if(this.experience.curIndex == 4)
                this.dragImg.classList.remove('up');
                else
                this.dragImg.classList.remove('side');
            }
        }).play();
    }

    swapToIslandStart()
    {     
        this.mode = 0;
        this.closeBtnElement.classList.remove('visible')
        this.catBtn.classList.remove('visible');
        this.grayIcon.src = "https://xrlab.studio/dev/Splittel/images/optronicsGray.png";
        this.grayIcon.classList.remove('visible');
        this.grayIcon.classList.add('halfVisible');        
        switch(this.experience.curIndex)
        {
            case 0:                
                this.uiSegmentOne.swapToIslandStart();
                break;
            case 1:
                this.uiSegmentTwo.swapToIslandStart();
                break;
            case 2:
                this.uiSegmentThree.swapToIslandStart();
                break;
            case 3:
                this.uiSegmentFour.swapToIslandStart();
            break;
            case 4:
                this.uiSegmentFive.swapToIslandStart();
            break;
            case 5:
                this.uiSegmentSix.swapToIslandStart();
            break;
        }
    }
    
    segmentIntroEnded()
    {            
        this.closeBtnElement.classList.add('visible')   
        this.catBtn.classList.add('visible');
        switch(this.experience.curIndex)
        {
            case 0:
                this.uiSegmentOne.segmentIntroEnded();
                break;
            case 1:
                this.uiSegmentTwo.segmentIntroEnded();
                break;
            case 2:
                this.uiSegmentThree.segmentIntroEnded();
                break;
            case 3:
                this.uiSegmentFour.segmentIntroEnded();
            break;
            case 4:
                this.uiSegmentFive.segmentIntroEnded();
            break;
            case 5:
                this.uiSegmentSix.segmentIntroEnded();
            break;
        }
    }
    swapToIslandEnd()
    {       
        switch(this.experience.curIndex)
        {
            case 0:
                this.segmentButton1.classList.add('visible')  
            break;
            case 1:
                this.segmentButton2.classList.add('visible')  
            break;
            case 2:
                this.segmentButton3.classList.add('visible')  
            break;
            case 3:
                this.segmentButton4.classList.add('visible')  
            break;
            case 4:
                this.segmentButton5.classList.add('visible')  
            break;
            case 5:
                this.segmentButton6.classList.add('visible')  
            break;
        }
        this.leftButton.classList.add('visible')       
        this.rightButton.classList.add('visible') 
        
    }
}